import React from 'react';

interface PageLoadingProps {
  msg?: string;
}

const PageLoading: React.FC<PageLoadingProps> = ({ msg }) => {
  return (
    <div className='flex justify-center items-center min-h-screen'>
      <div className='flex flex-col items-center gap-4'>
        {!msg && (
          <div className='relative w-12 h-12'>
            <div className='absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full' />
            <div className='absolute top-0 left-0 w-full h-full border-4 border-blue-500 border-t-transparent rounded-full animate-spin' />
          </div>
        )}
        {msg && <div className='text-gray-600 text-sm'>{msg}</div>}
      </div>
    </div>
  );
};

export default PageLoading;
